import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';
import { Button, Alert, AlertDescription } from '@pisaka/ui';
import { useModal } from '../../../hooks/useModal';
import { MODAL_NAME_CREATE_FONT } from '../../../constants/modalNamesConstants';

const FontCreatorControlPanelContainer: FC = () => {
  const { t } = useTranslation();
  const { onOpenModal } = useModal(MODAL_NAME_CREATE_FONT);

  return (
    <>
      <div className="flex justify-between items-center px-4 lg:px-6 py-4">
        <h1 className="text-xl font-semibold">Мои шрифты</h1>
        <Button
          onClick={onOpenModal}
          className="bg-gradient-accent hover:bg-accent shadow-accent text-primary-foreground"
        >
          {t('fontCreator.createNewFont')}
        </Button>
      </div>
      <div className="px-4 lg:px-6 mb-5">
        <Alert>
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>
            <span>{t('fontCreator.deviceHint')}</span>
            <br />
            <strong>{t('fontCreator.stylusHint')}</strong>
          </AlertDescription>
        </Alert>
      </div>
    </>
  );
};

export default FontCreatorControlPanelContainer;
